import { render, staticRenderFns } from "./quick-reply.vue?vue&type=template&id=b9bbf5e2&scoped=true"
import script from "./quick-reply.vue?vue&type=script&lang=js"
export * from "./quick-reply.vue?vue&type=script&lang=js"
import style0 from "./quick-reply.vue?vue&type=style&index=0&id=b9bbf5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bbf5e2",
  null
  
)

export default component.exports